import React from 'react';

import { Root, Trigger, Portal, Content, Arrow } from '@radix-ui/react-popover';
import IconChevron from '$partials/icons/icon-chevron';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/ui.d.ts').Popover}
 */
export const Popover = ({
    children,
    contentClassName,
    label,
    triggerClassName,
}) => {
    return (
        <Root>
            <Trigger className={triggerClassName}>
                {label}
                <span
                    aria-hidden={true}
                    className='popover__chevron ml-5'>
                    <IconChevron />
                </span>
            </Trigger>
            <Portal>
                <Content
                    className={`popover__content${contentClassName ? ` ${contentClassName}` : ''}`}
                    collisionPadding={48}>
                    {children}
                    <Arrow className='popover__arrow' />
                </Content>
            </Portal>
        </Root>
    );
};

/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

export default Popover;
